import React from 'react';

import { IContentTemplateData } from '../types';

import AccountSection from '../blocks/AccountSection';
import ChromeBoundary from '../primitives/ChromeBoundary';

interface IAccountBlockProps {
    data: IContentTemplateData;
    title?: string;
    description?: string;
}

const AccountBlock: React.FC<IAccountBlockProps> = ({ data, title, description }) => (
    <ChromeBoundary region="account">
        <AccountSection
            isLogged={data.isLogged}
            authStep={data.authStep}
            signupLabel={data.account.signupLabel}
            loggedLabel={data.account.loggedLabel}
            loggedUrl={data.account.loggedUrl}
            title={title}
            description={description}
        />
    </ChromeBoundary>
);

export default AccountBlock;
